// import images
import Logo from '../src/img/header/logo.png';
import GalleryImg1 from '../src/img/gallery/1.png';
import GalleryImg2 from '../src/img/gallery/2.png';
import GalleryImg3 from '../src/img/gallery/3.png';
import GalleryImg4 from '../src/img/gallery/4.png';
import GalleryImg5 from '../src/img/gallery/5.png';
import GalleryImg6 from '../src/img/gallery/6.png';
import GalleryImg7 from '../src/img/gallery/7.png';
import GalleryImg8 from '../src/img/gallery/8.png';
// rich images
// import Rich1 from '../src/img/richard/rich1.png';
// import Rich2 from '../src/img/richard/rich2.png';
// import Rich3 from '../src/img/richard/rich3.png';
// import Rich4 from '../src/img/richard/rich4.png';
// import Rich5 from '../src/img/richard/rich5.png';
// import Rich6 from '../src/img/richard/rich6.png';
// import Rich7 from '../src/img/richard/rich7.png';
// import Rich8 from '../src/img/richard/rich8.png';
// import Rich9 from '../src/img/richard/rich9.png';
// import Rich10 from '../src/img/richard/rich10.png';
// import Rich11 from '../src/img/richard/rich11.png';
// tommys photo
import tommy1 from '../src/img/tommy/tommy1.png';
import tommy2 from '../src/img/tommy/tommy2.png';
import tommy3 from '../src/img/tommy/tommy3.png';
import tommy4 from '../src/img/tommy/tommy4.png';
import tommy5 from '../src/img/tommy/tommy5.png';
import tommy6 from '../src/img/tommy/tommy6.png';
import tommy7 from '../src/img/tommy/tommy7.png';
import tommy8 from '../src/img/tommy/tommy8.png';
import tommy9 from '../src/img/tommy/tommy9.png';
import tommy10 from '../src/img/tommy/tommy10.png';
import tommy11 from '../src/img/tommy/tommy11.png';
import tommy12 from '../src/img/tommy/tommy12.png';
import tommy13 from '../src/img/tommy/tommy13.png';
import tommy14 from '../src/img/tommy/tommy14.png';
import tommy15 from '../src/img/tommy/tommy15.png';
import tommy16 from '../src/img/tommy/tommy16.png';
import tommy17 from '../src/img/tommy/tommy17.png';
import tommy18 from '../src/img/tommy/tommy18.png';
import tommy19 from '../src/img/tommy/tommy19.png';
import tommy20 from '../src/img/tommy/tommy20.png';
import tommy21 from '../src/img/tommy/tommy21.png';
import tommy22 from '../src/img/tommy/tommy22.png';
import tommy23 from '../src/img/tommy/tommy23.png';
import tommy24 from '../src/img/tommy/tommy24.png';
import tommy25 from '../src/img/tommy/tommy25.png';




import QuoteImg from '../src/img/testimonial/quote.svg';
// import icons
import { GrFacebookOption } from 'react-icons/gr';
import { IoMdArrowForward } from 'react-icons/io';
import { FiSend } from 'react-icons/fi';
import { FaPlay, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import {
  IoLogoInstagram,
  IoLogoPinterest,
  IoLogoTwitter,
  IoLogoYoutube,
} from 'react-icons/io';

export const headerData = {
  logo: Logo,
};

export const navData = {
  items: [
    { href: '/', name: 'Home' },
    { href: '/gallery', name: 'Gallery' },
    { href: '/#artist', name: 'Artist' },
    { href: '/#contact', name: 'Contact' },
    { href: '/#footer', name: 'Hours' },
    { href: '/#contact', name: 'Location' },
  ],
};

export const socialData = [
  { href: 'https://www.facebook.com/tattoosbytommyallenjohnson', icon: <GrFacebookOption /> },
  { href: 'https://www.instagram.com/after.the.fallout.tattoos/', icon: <IoLogoInstagram /> },
];

export const heroData = {
  title: 'AFTER THE FALLOUT',
  subtitle:
    'TATTOO CO.',
  btnText: 'LEARN MORE',
  btnIcon: <IoMdArrowForward />,
};

export const aboutData = {
  title: 'Our Story:',
  subtitle1:
    'After the Fallout Tattoo Co. seamlessly merges timeless appeal with modern refinement, leveraging nearly four decades of collective expertise. Following 20 years of industry experience, the owner launched his bespoke vision in 2022. We specialize in American traditional tattoos while embracing varied artistic styles. Our talented artists focus on exceeding client expectations within our walls, offering complimentary consultations and competitive pricing.',

};

export const galleryData = {
  title: 'Our Gallery:',
  btnText: 'View all',
  btnIcon: <IoMdArrowForward />,
  images: [
    {
      src: GalleryImg1,
      original: GalleryImg1,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg2,
      original: GalleryImg2,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg3,
      original: GalleryImg3,
      width: 465,
      height: 412,
    },
    {
      src: GalleryImg4,
      original: GalleryImg4,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg5,
      original: GalleryImg5,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg6,
      original: GalleryImg6,
      width: 464,
      height: 412,
    },
    {
      src: GalleryImg7,
      original: GalleryImg7,
      width: 465,
      height: 540,
    },
    {
      src: GalleryImg8,
      original: GalleryImg8,
      width: 465,
      height: 412,
    },
  ],
};

export const interviewData = {
  title:
    '"Consider what you desire. Your tattoo artist will never tell you what tattoo to have."',
  btnText: 'Watch it now',
  btnIcon: <FaPlay />,
};

export const testimonialData = [
  {
    quoteImg: QuoteImg,
    message:
      "Tommy is amazing  I highly recommend him and his staff. Very professional. Super clean shop a all around great experience.",
    name: 'Stacy Parker-Damon',
  
  },
  {
    quoteImg: QuoteImg,
    message:
      "Tommy is the go to guy for all my work and he has even done work on my girls.",
    name: 'Chuck Sekeres',
  
  },
  {
    quoteImg: QuoteImg,
    message:
      "I have over 10 tattoos done by Tommy Johnson, and they are all exceptional. Fair prices, great work, diverse portfolio. Generally a great guy and will make you feel comfortable regardless what walk of life you come from.",
    name: 'Theo Jones',
  
  },
  {
    quoteImg: QuoteImg,
    message:
      'Great artist to get tattooed by ! Highly recommend. Great Prices, very clean shop and a overall amazing experience and quality work.',
    name: 'Stirling Smith',
  },
];

export const contactData = {
  title: 'Get in touch with me:',
  info: [
    {
      title: 'LA office',
      subtitle:
        'In velit arcu posuere integer sit amet, consectetur nun adipiscing elit. Duis porttitor massa tellus',
      address: {
        icon: <FaMapMarkerAlt />,
        name: '784 Norman Street, Los Angeles',
      },
      phone: {
        icon: <FaPhoneAlt />,
        number: '+49 93 30493943',
      },
      email: {
        icon: <FaEnvelope />,
        address: 'contact@yourcompany.com',
      },
      link: 'Get location',
    },
    {
      title: 'NYC office',
      subtitle:
        'Sit amet, consectetur nun in velit arcu posuere integer. Adipiscing elit duis porttitor massa tellus',
      address: {
        icon: <FaMapMarkerAlt />,
        name: '1630 Elm Drive, New York City',
      },
      phone: {
        icon: <FaPhoneAlt />,
        number: '+49 34 36573355',
      },
      email: {
        icon: <FaEnvelope />,
        address: 'contact@yourcompany.com',
      },
      link: 'Get location',
    },
  ],
  form: {
    name: 'Write your name here',
    email: 'Write your email address',
    message: 'Write your messages here',
    btnText: 'Send it',
  },
};

export const footerData = {
  about: {
    title: 'About void tattoo',
    subtitle:
      'Sit amet, consectetur nun in velit arcu posuere integer. Adipiscing elit duis porttitor massa tellus',
    address: {
      icon: <FaMapMarkerAlt />,
      name: '1630 Elm Drive, New York City',
    },
    phone: {
      icon: <FaPhoneAlt />,
      number: '+49 34 36573355',
    },
    email: {
      icon: <FaEnvelope />,
      address: 'contact@yourcompany.com',
    },
  },
  links: {
    title: 'Useful links',
    items: [
      { href: '/', name: 'About me' },
      { href: '/', name: 'My gallery' },
      { href: '/', name: 'My services' },
      { href: '/', name: 'Contact me' },
    ],
  },
  program: {
    title: 'Working Time',
    items: [
      { name: 'Mon - Tue / Appointment' },
      { name: 'Wed - Fri / 10:00 - 9:00pm' },
      { name: 'Sat / 10:00 - 6:00pm' },
      { name: 'Sun / no work on this day' },
    ],
  },
  newsletter: {
    title: 'Newsletter',
    subtitle:
      'Elit duis porttitor massa tellus nun in velit arcu posuere integer.',
    form: {
      placeholder: 'Your email address',
      icon: <FiSend />,
    },
  },
};

// galleryData.js
export const galleryPageData = {
  title: "Our Tattoo Gallery",
  btnText: "View All",
  btnIcon: "🔍",
  images: [
    {
      src: tommy10, // Add this line
      original: tommy10,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich1, // Add this line
    //   original: Rich1,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy11, // Add this line
      original: tommy11,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich2, // Add this line
    //   original: Rich2,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy12, // Add this line
      original: tommy12,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich3, // Add this line
    //   original: Rich3,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy13, // Add this line
      original: tommy13,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich4, // Add this line
    //   original: Rich4,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy14, // Add this line
      original: tommy14,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich5, // Add this line
    //   original: Rich5,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy15, // Add this line
      original: tommy15,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich6, // Add this line
    //   original: Rich6,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy16, // Add this line
      original: tommy16,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich7, // Add this line
    //   original: Rich7,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy17, // Add this line
      original: tommy17,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich8, // Add this line
    //   original: Rich8,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy18, // Add this line
      original: tommy18,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich9, // Add this line
    //   original: Rich9,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy19, // Add this line
      original: tommy19,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich10, // Add this line
    //   original: Rich10,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy20, // Add this line
      original: tommy20,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    // {
    //   src: Rich11, // Add this line
    //   original: Rich11,
    //   width: 700,
    //   height: 600,
    //   artist: "Richard",
    // },
    {
      src: tommy21, // Add this line
      original: tommy21,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy1, // Add this line
      original: tommy1,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy2, // Add this line
      original: tommy2,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy3, // Add this line
      original: tommy3,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy4, // Add this line
      original: tommy4,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy5, // Add this line
      original: tommy5,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy6, // Add this line
      original: tommy6,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy7, // Add this line
      original: tommy7,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy8, // Add this line
      original: tommy8,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy9, // Add this line
      original: tommy9,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy22, // Add this line
      original: tommy22,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy23, // Add this line
      original: tommy23,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy24, // Add this line
      original: tommy24,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    {
      src: tommy25, // Add this line
      original: tommy25,
      width: 700,
      height: 600,
      artist: "Tommy",
    },
    
  ],
};